const impressionStatusList = (state = {}, action) => {
    switch (action.type) {
        case 'SET_LIST_OF_IMP_STATUS':
            return {
                ...state,
                impList: action.payload
            };
        default:
            return state;
    }
};

export default impressionStatusList;
